module.exports = __webpack_public_path__ + "img/scrub-back.7fb5849c.svg";